<script>
import IconMixin from '../Mixins/IconMixin';

export default {
  name: 'IcoMoon',
  mixins: [IconMixin],
  props: {
    iconSet: {
      required: true,
      type: Object,
    },
    focusable: {
      required: false,
      type: String,
      default: 'true',
    },
  },
  render(createElement) {
    const { name, size, color, iconSet, focusable } = this;

    const find = (iconEl) => iconEl.properties.name.split(', ').includes(name);
    const currentIcon = iconSet.icons.find(find);

    let styles = {};

    if (color) {
      styles.fill = color;
    }

    const renderPath = (iconObj) => (path, index) => {
      const attrs = (iconObj.attrs && iconObj.attrs[index]) || {};

      return createElement('path', {
        attrs: {
          key: index,
          d: path,
          ...attrs,
        },
      });
    };

    const className = ['icon', `icon-${name}`];

    return createElement(
      'svg',
      {
        class: className,
        style: {
          ...styles,
        },
        attrs: {
          focusable: focusable,
          width: size,
          height: size,
          viewBox: `0 0 ${currentIcon.icon.width || '1024'} 1024`,
        },
      },
      currentIcon.icon.paths.map(renderPath(currentIcon.icon)),
    );
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/icon.styl';
</style>
